import clsx from "clsx";
import { PropsWithChildren } from "react";
import { Link } from "react-router-dom";

import css from "./index.module.scss";

type Props = {
  className?: string;
  secondary?: boolean;
  small?: boolean;
  to: string;
};

export const HeaderButton = ({
  children,
  className,
  secondary = false,
  small = false,
  to,
}: PropsWithChildren<Props>) => {
  return (
    <Link
      className={clsx(
        css.button,
        secondary && css.secondary,
        small && css.small,
        className,
      )}
      to={to}
    >
      {children}
    </Link>
  );
};
